import { useStores } from "./useStores";
import type { UploadQueueStoreInstance } from "@/stores/types";

/**
 * Hook to access the UploadQueueStore from the root store.
 * Follows the same pattern as other domain store hooks.
 *
 * @example
 * ```tsx
 * import { useUploadQueueStore } from "@/hooks/useUploadQueueStore";
 *
 * function UploadProgress() {
 *   const uploadStore = useUploadQueueStore();
 *
 *   return (
 *     <div>
 *       <p>{uploadStore.completedCount} / {uploadStore.totalCount} complete</p>
 *       <Progress value={uploadStore.overallProgress} />
 *     </div>
 *   );
 * }
 * ```
 */
export function useUploadQueueStore(): UploadQueueStoreInstance {
  const { uploadQueueStore } = useStores();
  return uploadQueueStore;
}
